// extracted by mini-css-extract-plugin
module.exports = {"cart-icon":"bc_dx","cartIcon":"bc_dx","badge":"bc_dy"};